var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3501 18.3506C15.1826 18.3506 19.1001 14.4331 19.1001 9.60058C19.1001 4.76809 15.1826 0.850586 10.3501 0.850586C5.51761 0.850586 1.6001 4.76809 1.6001 9.60058C1.6001 14.4331 5.51761 18.3506 10.3501 18.3506Z",
    stroke: "#9BCB49",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9751 7.65614C12.9751 7.65614 11.8942 6.10059 10.0927 6.10059C8.29127 6.10059 6.8501 7.65614 6.8501 9.60059C6.8501 11.545 8.29127 13.1006 10.0927 13.1006C11.8942 13.1006 12.9751 11.545 12.9751 11.545",
    stroke: "#9BCB49",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyright);
export default __webpack_public_path__ + "static/media/Icon-copyright.1b4936962ad6dbea4ffb7fc02f845740.svg";
export { ForwardRef as ReactComponent };